import { useState } from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
// import { Search as SearchIcon } from "react-feather";
// import { useTranslation } from "react-i18next";

import { green } from "@mui/material/colors";
import {
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Chip,
  Typography,
} from "@mui/material";

import { Menu as MenuIcon } from "@mui/icons-material";

import NavbarBranchDropdown from "./NavbarBranchDropdown";
import NavbarNotificationsDropdown from "./NavbarNotificationsDropdown";
import NavbarMessagesDropdown from "./NavbarMessagesDropdown";
import NavbarLanguagesDropdown from "./NavbarLanguagesDropdown";
import NavbarUserDropdown from "./NavbarUserDropdown";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const BrandChip = styled(Chip)`
  background-color: ${green[700]};
  border-radius: 5px;
  color: ${(props) => props.theme.palette.common.white};
  font-size: 55%;
  height: 18px;
  margin-left: 2px;
  margin-top: -16px;
  padding: 3px 0;

  span {
    padding-left: ${(props) => props.theme.spacing(1.375)};
    padding-right: ${(props) => props.theme.spacing(1.375)};
  }
`;

const Navbar = ({ onDrawerToggle, companies }) => {
  // const { t } = useTranslation();
  const [hideSideBar, setHideSideBar] = useState(
    localStorage.getItem("HIDE_SIDE_MENU")
  );
  let displayProps = {};
  if (hideSideBar) {
    displayProps = { xs: "block" };
  } else {
    displayProps = { xs: "block", md: "none" };
  }

  return (
    <>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item sx={{ display: { ...displayProps } }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            <Grid item>
              {!!hideSideBar && (
                <div style={{ marginLeft: "40px" }}>
                  <Typography variant="h5" color="primary">
                    Beta <BrandChip label="ERP" />
                    {/* Title */}
                    {/* Abubakr's Form With Hook */}
                  </Typography>
                </div>
              )}
              {/* <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <Input placeholder={t("Search")} />
              </Search> */}
            </Grid>
            {companies && companies.length && (
              <Grid item>
                <NavbarBranchDropdown companyOptions={companies} />
              </Grid>
            )}

            <Grid item xs />
            <Grid item>
              {/* TODO >> REACTIVAATE THIS SECTIONS
              <NavbarMessagesDropdown />
              <NavbarNotificationsDropdown />
              */}
               <NavbarLanguagesDropdown />
              <NavbarUserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default withTheme(Navbar);
